import { useState } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsStaggered, faClose, faShop } from '@fortawesome/free-solid-svg-icons';
import { PageTitle } from "../../config/config";

export default function Navigation({ selectedCategory = "All", setSelectedCategory = () => {} }) {
  const [sideMenu, setSideMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const categories = [
    "All",
    "Shoes",
    "Hoodies/Sweaters",
    "T-Shirts",
    "Jackets",
    "Pants/Shorts",
    "Headwear",
    "Accessories",
    "Other Stuff"
  ];

  const onCategoryClick = (cat) => {
    window.scrollTo({ top: 0, behavior: 'instant' }); // 🔁 scroll first

    if (location.pathname !== '/products') {
      navigate('/products', { state: { category: cat } });
    } else {
      setSelectedCategory(cat);
    }

    setSideMenu(false);
  };

  const navigationSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Product Categories",
    "itemListElement": categories.map((cat, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": cat,
      "url": "https://www.superbuyspreadsheet.net/products" // or your homepage URL if preferred
    })),
  };



  return (
    <nav
      id="navigation"
      className="sticky-nav flex h-[100px] container mx-auto items-center justify-between max-sm:p-8 relative"
    >
      
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(navigationSchema) }}
      />
      
      {/* Logo */}
      <Link to="/" className="flex items-center gap-x-2 z-[110]">
        <FontAwesomeIcon style={{ color: 'var(--call-to-action-color)' }} icon={faShop} />
        <span className="navbrandtxt uppercase mr-4 tracking-wide">{PageTitle}</span>
      </Link>

      {/* Desktop category buttons (only show on large screens) */}
      <div className="hidden lg:flex items-center gap-8">
        <div className="flex gap-2">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => onCategoryClick(cat)}
              className={`px-3 py-1 rounded ${
                selectedCategory === cat
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-blue-500 hover:text-white'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Mobile menu toggle icon (visible on screens smaller than lg) */}
      <FontAwesomeIcon
        onClick={() => setSideMenu(!sideMenu)}
        icon={sideMenu ? faClose : faBarsStaggered}
        style={{ color: 'var(--call-to-action-color)' }}
        className="cursor-pointer z-[110] w-[24px] text-xl lg:hidden"
      />

      {/* Mobile menu (shows on smaller than lg screens) */}
      {sideMenu && (
        <div
          className="fixed top-[100px] left-0 w-full h-[calc(100vh-100px)] bg-white z-[105] p-6 flex flex-col gap-6 overflow-auto lg:hidden shadow-lg"
          onClick={() => setSideMenu(false)}
        >
          <div className="flex flex-col gap-3 mt-4">
            {categories.map(cat => (
              <button
                key={cat}
                onClick={(e) => {
                  e.stopPropagation(); // prevent early menu close
                  onCategoryClick(cat);
                }}
                className={`px-3 py-2 rounded text-left ${
                  selectedCategory === cat
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-blue-500 hover:text-white'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
